var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PluginActions } from "./PluginStateHandling";
import { ImgEventHandler } from "./ImgEventHandler";
import { TypeRendererRegistry } from "./TypeRendererRegistry";
var PluginRegistry = /** @class */ (function () {
    function PluginRegistry() {
        var _this = this;
        this._store = {
            getState: function () { return ({}); },
            dispatch: function (p) { return p; },
            subscribe: function (callback) { }
        };
        this._stateEventHandler = new ImgEventHandler();
        this._loadingPlugins = new ImgEventHandler();
        this._loadedPlugin = new ImgEventHandler();
        this._typeRendererRegistry = new TypeRendererRegistry();
        this._backEndUrl = "";
        this._pluginsToLoad = [];
        this.addPluginToLoad = function (name, local) {
            _this._pluginsToLoad.push({ name: name, local: local });
        };
        this.loadPlugins = function (params) {
            var store = params.store, restParams = __rest(params, ["store"]);
            _this._store = store;
            _this._actions = PluginActions;
            _this._store.subscribe(function () { return _this._stateEventHandler.trigger({ state: _this._store.getState(), dispatch: _this._store.dispatch }); });
            var toLoad = _this._pluginsToLoad.slice(0);
            _this._pluginsToLoad = [];
            var count = toLoad.length;
            var loaded = 0;
            var promises = [];
            _this.loadingPlugins.trigger({ count: count, current: 0, name: "" });
            var pp = __assign(__assign({}, restParams), { state: store.getState(), dispatch: store.dispatch });
            toLoad.forEach(function (p) {
                promises.push(new Promise(function (res, rej) {
                    var req = new XMLHttpRequest();
                    if (p.local && process.env.NODE_ENV !== "production") {
                        console.log("loading plugin from public: " + p.name);
                        req.open("GET", "./plugins/" + p.name + ".plugin.js");
                    }
                    else {
                        req.open("GET", _this._backEndUrl + "/plugins/" + p.name + ".plugin.js");
                    }
                    req.onload = function () {
                        //console.log(req.status);
                        if (req.status === 200) {
                            //                        console.log(req.responseText);
                            _this.loadedPlugin.trigger(p.name);
                            // eslint-disable-next-line
                            eval(req.responseText).init(pp);
                            _this._loadingPlugins.trigger({ count: count, current: ++loaded, name: p.name });
                            res();
                        }
                    };
                    req.send();
                }));
            });
            return new Promise(function (res, rej) { return Promise.all(promises).then(function () {
                var _a;
                if (_this._store && _this._stateEventHandler)
                    (_a = _this._stateEventHandler) === null || _a === void 0 ? void 0 : _a.trigger({ state: _this._store.getState(), dispatch: _this._store.dispatch });
                res();
            }, rej); });
        };
        this.pluginsToLoadCount = function () {
            return _this._pluginsToLoad.length;
        };
        window.platformPluginRegistry = this;
    }
    Object.defineProperty(PluginRegistry.prototype, "loadedPlugin", {
        get: function () { return this._loadedPlugin.expose(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginRegistry.prototype, "loadingPlugins", {
        get: function () { return this._loadingPlugins.expose(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginRegistry.prototype, "stateEventHandler", {
        get: function () { return this._stateEventHandler.expose(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginRegistry.prototype, "backEndUrl", {
        set: function (url) {
            this._backEndUrl = url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginRegistry.prototype, "baseClient", {
        get: function () {
            return this._baseClient;
        },
        set: function (client) {
            this._baseClient = client;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginRegistry.prototype, "store", {
        get: function () {
            return this._store;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginRegistry.prototype, "actions", {
        get: function () {
            return this._actions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginRegistry.prototype, "typeRendererRegistry", {
        get: function () {
            return this._typeRendererRegistry;
        },
        enumerable: true,
        configurable: true
    });
    PluginRegistry.getInstance = function () {
        if (PluginRegistry._instance === undefined)
            PluginRegistry._instance = new PluginRegistry();
        return PluginRegistry._instance;
    };
    return PluginRegistry;
}());
export { PluginRegistry };
